import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { confirmOrder } from '../helpers/confirm-order';

interface ConfirmOrderForSubscriptionChangeFnPayload {
    orderId: string;
}

export type ConfirmOrderForSubscriptionChangeFn = (
    payload: ConfirmOrderForSubscriptionChangeFnPayload,
) => Promise<string>;

export function initConfirmOrderForSubscriptionChangeFn({
    dependencies,
}: DomainInitPayload): ConfirmOrderForSubscriptionChangeFn {
    const { appEventSdk } = dependencies;
    return async ({ orderId }: ConfirmOrderForSubscriptionChangeFnPayload) => {
        try {
            const result = await confirmOrder({ orderId }, dependencies);

            const subscriptionId =
                result?.subscriptionPlanSwitch?.subscriptionId;
            if (!subscriptionId) {
                throw new Error('Subscription plan switch not created.');
            }

            appEventSdk.trackEvent({
                event: 'customer-info',
                customerInfo: {
                    customerType: 'SXIR_SELFPAY',
                    subscriptions: [
                        {
                            id: subscriptionId,
                        },
                    ],
                },
            });
            appEventSdk.trackEvent({
                event: 'order-confirmed',
                subscriptionInfo: [
                    {
                        id: subscriptionId,
                        orderId,
                    },
                ],
            });

            return subscriptionId;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
